<script lang="ts">
  import type { BulkEditValues } from '../../types/transaction';
  import { Button, SearchableSelect } from '../common';

  let {
    selectedCount = 0,
    categories = [],
    values = $bindable({} as BulkEditValues),
    onSave,
    onCancel,
    onCreateCategory
  }: {
    selectedCount: number;
    categories: string[];
    values?: BulkEditValues;
    onSave: () => void;
    onCancel: () => void;
    onCreateCategory?: (categoryName: string) => Promise<void>;
  } = $props();
</script>

<div class="bulk-edit-panel">
  <h3>Bulk Edit {selectedCount} Transactions</h3>
  <div class="bulk-edit-form">
    <div class="form-group">
      <label>Category</label>
      <SearchableSelect
        bind:value={values.category}
        options={categories}
        placeholder="Search categories..."
        onCreate={onCreateCategory}
      />
    </div>
    <div class="form-group">
      <label>Display Name (optional)</label>
      <input
        type="text"
        bind:value={values.displayName}
        placeholder="Leave empty to keep original names"
        class="display-name-input"
      />
    </div>
  </div>
  <div class="bulk-edit-actions">
    <Button variant="success" size="md" onclick={onSave}>Save Changes</Button>
    <Button variant="secondary" size="md" onclick={onCancel}>Cancel</Button>
  </div>
</div>

<style lang="scss">
  .bulk-edit-panel {
    position: sticky;
    top: 0;
    z-index: 99;
    background: white;
    border-bottom: 3px solid var(--color-primary-bright);
    padding: var(--spacing-xl);
    box-shadow: var(--shadow-lg);

    h3 {
      margin: 0 0 var(--spacing-lg) 0;
      font-size: var(--font-size-lg);
      color: var(--color-text-primary);
    }

    .bulk-edit-form {
      display: grid;
      grid-template-columns: 1fr;
      gap: var(--spacing-lg);
      margin-bottom: var(--spacing-lg);
      max-width: 600px;

      @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
      }
    }

    .form-group {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-sm);

      label {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-medium);
        color: var(--color-text-secondary);
      }

      .display-name-input {
        padding: var(--spacing-sm) var(--spacing-md);
        border: 1px solid var(--color-border);
        border-radius: var(--radius-md);
        font-size: var(--font-size-sm);
        background: var(--color-background);
        transition: all var(--transition-fast);

        &:focus {
          outline: none;
          border-color: var(--color-primary);
          box-shadow: var(--shadow-focus-ring);
        }

        &:hover {
          border-color: var(--color-text-muted);
        }

        &::placeholder {
          color: var(--color-text-muted);
        }
      }
    }

    .bulk-edit-actions {
      display: flex;
      gap: var(--spacing-sm);
    }
  }
</style>
